import React from 'react';

interface ConfirmModalProps {
    isOpen: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
    type?: 'danger' | 'warning' | 'info';
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    isOpen,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    type = 'danger'
}) => {
    if (!isOpen) return null;

    const iconClass = type === 'danger' ? 'fa-trash-can text-rose-600' : type === 'warning' ? 'fa-triangle-exclamation text-amber-500' : 'fa-circle-info text-blue-600';
    const bgColor = type === 'danger' ? 'bg-rose-50' : type === 'warning' ? 'bg-amber-50' : 'bg-blue-50';

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-[#05144b]/40 backdrop-blur-sm animate__animated animate__fadeIn">
            <div className="bg-white rounded-[2rem] w-full max-w-md overflow-hidden shadow-2xl animate__animated animate__zoomIn">
                <div className="p-8 text-center">
                    <div className={`w-20 h-20 ${bgColor} rounded-full flex items-center justify-center mx-auto mb-6`}>
                        <i className={`fa-solid ${iconClass} text-3xl`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-[#05144b] mb-2">{title}</h3>
                    <p className="text-slate-500 font-medium text-sm mb-8 leading-relaxed">
                        {message}
                    </p>
                    
                    <div className="flex flex-col gap-3">
                        <button 
                            onClick={(e) => {
                                e.stopPropagation();
                                onConfirm();
                            }}
                            className={`w-full py-4 ${type === 'danger' ? 'bg-rose-600 hover:bg-rose-700' : 'bg-[#05144b] hover:bg-blue-900'} text-white rounded-2xl font-bold text-xs shadow-lg transition-all active:scale-95`}
                        >
                            {confirmText}
                        </button>
                        <button 
                            onClick={(e) => {
                                e.stopPropagation();
                                onCancel();
                            }}
                            className="w-full py-4 bg-slate-50 text-slate-600 rounded-2xl font-bold text-xs hover:bg-slate-100 transition-all active:scale-95"
                        >
                            {cancelText}
                        </button>
                    </div>
                </div>
                <div className="bg-slate-50/50 p-4 text-center border-t border-slate-100">
                    <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Property Guru Security System</p>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
